/* eslint-disable */
import axiosInstance from 'api/axios';

export interface APIResponseData<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface BlogChangeResponse {
  success: boolean;
  message: string;
  data: string;
}

interface BlogMetaIndustries {
  "id": string;
    "name": string;
}

export const blogService = {
  changeTone: async (
    selectedText: string,
    context: string,
    tone: string
  ): Promise<APIResponseData<string>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/change/tone',
      {
        selected_text: selectedText,
        context,
        tone,
      }
    );
    return response.data;
  },

  changeLength: async (
    selectedText: string,
    context: string,
    tone: string,
    operation: string
  ): Promise<APIResponseData<string>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/change/length',
      {
        selected_text: selectedText,
        context,
        tone,
        operation,
      }
    );
    return response.data;
  },

  checkGrammar: async (
    context: string
  ): Promise<APIResponseData<string | BlogChangeResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/grammar/check',
      {
        context,
      }
    );
    return response.data;
  },

  continueWriting: async (
    selectedText: string,
    context: string,
    tone: string
  ): Promise<APIResponseData<string>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/change/continue',
      {
        selected_text: selectedText,
        context,
        tone,
      }
    );
    return response.data;
  },

  getAllIndustries:  async (): Promise<APIResponseData<BlogMetaIndustries[]>> => {
    const response = await axiosInstance.private.get(
      '/api/v1/blogs/meta/industries',
    );
    return response.data;
  },
};
